<template>
  <div class="calc">
    <div class="result">
      <fitty :options="resultOptions">
        <template v-slot:content>
          {{ result }}
        </template>
      </fitty>
    </div>

    <div class="btn-group">
      <div class="container h-100">
        <div class="row h-100">
          <div class="col-3 btn-col">
            <div @click.prevent="clear" class="button">C</div>
          </div>
          <div class="col-3 btn-col">
            <div @click.prevent="invert" class="button">+/-</div>
          </div>
          <div class="col-3 btn-col">
            <div @click.prevent="percent" class="button">%</div>
          </div>
          <div class="col-3 btn-col">
            <div @click.prevent="setOperator('/')" class="button">/</div>
          </div>
          <div class="col-3 btn-col">
            <div @click.prevent="append(7)" class="button number">7</div>
          </div>
          <div class="col-3 btn-col">
            <div @click.prevent="append(8)" class="button number">8</div>
          </div>
          <div class="col-3 btn-col">
            <div @click.prevent="append(9)" class="button number">9</div>
          </div>
          <div class="col-3 btn-col">
            <div @click.prevent="setOperator('*')" class="button">x</div>
          </div>
          <div class="col-3 btn-col">
            <div @click.prevent="append(4)" class="button number">4</div>
          </div>
          <div class="col-3 btn-col">
            <div @click.prevent="append(5)" class="button number">5</div>
          </div>
          <div class="col-3 btn-col">
            <div @click.prevent="append(6)" class="button number">6</div>
          </div>
          <div class="col-3 btn-col">
            <div @click.prevent="setOperator('-')" class="button">-</div>
          </div>
          <div class="col-3 btn-col">
            <div @click.prevent="append(1)" class="button number">1</div>
          </div>
          <div class="col-3 btn-col">
            <div @click.prevent="append(2)" class="button number">2</div>
          </div>
          <div class="col-3 btn-col">
            <div @click.prevent="append(3)" class="button number">3</div>
          </div>
          <div class="col-3 btn-col">
            <div @click.prevent="setOperator('+')" class="button">+</div>
          </div>
          <div class="col-6 btn-col">
            <div @click.prevent="append(0)" class="button number">0</div>
          </div>
          <div class="col-3 btn-col">
            <div @click.prevent="addPoint" class="button number">.</div>
          </div>
          <div class="col-3 btn-col">
            <div @click.prevent="equal" class="button">=</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Calc",
  data: function () {
    return {
      result: "0",
      tmp_value: 0,
      reset: false,
      operator: undefined,
      resultOptions: {
        maxSize: 100,
      },
    };
  },
  methods: {
    clear() {
      this.result = "0";
      this.tmp_value = 0;
      this.operator = undefined;
    },
    invert() {
      this.result *= -1;
    },
    percent() {
      this.result /= 100;
    },
    append(number) {
      if ((this.result == 0 && this.result !== "0.") || this.reset === true) {
        this.result = "";
        this.reset = false;
      }

      if (this.result.length > 12) return;

      this.result += number.toString();
    },
    addPoint() {
      if (!this.result.includes(".")) this.result += ".";
    },
    setOperator(operator) {
      if (this.tmp_value != 0) this.calculate();

      this.tmp_value = this.result;
      this.operator = operator;
      this.reset = true;
    },
    equal() {
      this.calculate();
      this.tmp_value = 0;
      this.operator = undefined;
    },
    calculate() {
      let value = 0;
      let firstNum = parseFloat(this.tmp_value);
      let secondNum = parseFloat(this.result);

      switch (this.operator) {
        case "+":
          value = firstNum + secondNum;
          break;
        case "-":
          value = firstNum - secondNum;
          break;
        case "*":
          value = firstNum * secondNum;
          break;
        case "/":
          value = firstNum / secondNum;
      }

      this.result = value.toString();
    },
  },
};
</script>

<style lang="scss" scoped>
.calc {
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  height: 100%;
  max-height: 180vw;
  width: 100%;
  max-width: 60vh;
  text-align: center;
  // background-color: red;

  .result {
    height: 30%;
    width: 100%;
    overflow: hidden;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }

  .btn-group {
    height: 70%;
    width: 100%;
    overflow: hidden;
  }
}

.btn-col {
  height: 20%;
  padding: 10px;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.button {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #56cbdb;
  color: #262834;
  border-radius: 20px;
  transition: all 0.1s;
  font-size: x-large;

  &:hover {
    transform: scale(1.1);
    font-size: xx-large;
    background-color: #fff;
  }

  &.number {
    background-color: #262834;
    color: #d8f1f5;
  }
}
</style>
